var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Layout } from 'react-admin';
import { ApiHubAppBar } from './ApiHubAppBar';
import { ApiHubMenu } from './ApiHubMenu';
import { useSelector } from 'react-redux';
/**
 * The ApiHub Layout used in the ApiHub Admin.
 *
 * @param {*} appBar The AppBar component
 * @param {*} sidebar The Sidebar component
 * @param {*} menu The Menu component
 * @param {*} rest The other Layout properties
 */
export const ApiHubLayout = (_a) => {
    var { appBar = ApiHubAppBar, menu = ApiHubMenu } = _a, rest = __rest(_a, ["appBar", "menu"]);
    // In order to let the components use Redux-based dataProvider
    // hooks like useGetOne, we must wait for the resource registration before
    // displaying the dashboard.
    // This fix should be reverted after the release of React Admin v3.6.3.
    const resourcesAreRegistered = useSelector(state => Object.keys(state.admin.resources).length > 0);
    if (!resourcesAreRegistered) {
        return null;
    }
    return React.createElement(Layout, Object.assign({ appBar: appBar, menu: menu }, rest));
};
//# sourceMappingURL=ApiHubLayout.js.map